import { EPrescriptionType } from './enums/goods';
import { env } from './env';
import { IS_UK } from './constants';

// DNS预取域名列表 - 第三方服务域名
export const prefetchList = [
  // Google服务
  'https://www.googletagmanager.com',
  'https://apis.google.com',

  env.NEXT_PUBLIC_S3_URL,
  'https://common.xmslol.com',
];

export const ACCOUNT_WHITE_LIST_NEW = [
  '/account/points-mall',
  '/account/points-mall-detail',
  '/account/refer-a-friend',
  '/account/redeemable-items',
  '/account/redeemable-detail',
  '/account/zeelool-rewards',
];

export const BLOG_MARK_LIST = {
  ALL_BLOGS: 'all_blogs',
  SHOP_ZEELOOL: 'shop_zeelool',
};
// 欧盟国家
export const EU_REGION = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'GB', // 额外添加 GB
];
export const LOCALE_TYPES = {
  EN: 'en',
  DE: 'de',
  ES: 'es',
  FR: 'fr',
  IT: 'it',
  PT: 'pt',
  FI: 'fi',
  NL: 'nl',
} as const;

export type LocaleType = (typeof LOCALE_TYPES)[keyof typeof LOCALE_TYPES];

export const NAVIGATION_KEYS = {
  DASHBOARD: 'dashboard',
  MY_ACCOUNT: 'my_account',
  ORDER_MANAGEMENT: 'order_management',
  MY_ASSETS: 'my_assets',
  PERSONALIZATION: 'personalization',
  MEMBERSHIP_HUB: 'membership_hub',
  // 子项键值
  ACCOUNT_SETTINGS: 'account_settings',
  PRESCRIPTIONS: 'prescriptions',
  ADDRESS_BOOK: 'address_book',
  REVIEWS: 'reviews',
  ACCOUNT_SECURITY: 'account_security',
  QUESTIONNAIRES: 'questionnaires',
  ZEELOOL_REWARDS: 'zeelool_rewards',
  ZING: 'zing',
  REWARDS_STORE: 'rewards_store',
  MY_ORDERS: 'my_orders',
  TICKETS: 'tickets',
  COUPONS: 'coupons',
  STORE_CREDIT: 'store_credit',
  MY_CARD: 'my_card',
  WISHLIST: 'wishlist',
  REFER_FRIEND: 'refer_friend',
  RECENTLY_VIEWED: 'recently_viewed',
  COMMUNICATION_PREFERENCES: 'communication_preferences',
  CONSUMER_AFFILIATE: 'consumer_affiliate',
  MANAGE_AUTO_RENEWAL: 'manage_auto_renewal',
} as const;

export type NavigationKey = (typeof NAVIGATION_KEYS)[keyof typeof NAVIGATION_KEYS];

/**
 * @description: 支付相关配置
 */
const cardDisplayName =
  env.NEXT_PUBLIC_SITE_NAME === 'fr' ? 'Carte bancaire' : 'Credit / Debit Card';

export const PAY_TYPE_MAP = Object.freeze({
  paypal_express: 'Paypal',
  klarna: 'Klarna',
  klarna_adyen: 'Klarna',
  adyen: cardDisplayName,
  afterpay: IS_UK ? 'Clearpay' : 'Afterpay',
  googlepay: 'Google Pay',
  applepay: 'Apple Pay',
  cashondelivery: '', // 预留，暂时没用
  skip: 'Skip', // 积分兑换免费
  wallet: 'Store Credit', // 钱包

  useepay_card: cardDisplayName,
  card: cardDisplayName,
  paypal: 'PayPal',
});

// 前端常量 - 数据表固定值
export const PAY_METHODS = Object.freeze({
  PAYPAL: 'paypal',
  CARD: 'card',
  KLARNA_ADYEN: 'klarna_adyen',
  KLARNA: 'klarna',
  AFTER_PAY: 'afterpay',
  APPLE_PAY: 'applepay',
  WALLET: 'wallet',
});

// 商品列表页的默认排序值
export const DEFAULT_SORT_VALUE = 'Relevance';
/**
 * 获取协议、上报都用这个，抽个常量避免 string 容易出错
 */
export const COMPLIANCE_SCENE_CODES = {
  QUICK_AUTH: 'web.quick_auth',
  REGISTER: 'web.register',
  LOGIN: 'web.login',
  LOGIN_THIRD_PARTY: 'web.login_third_party',
  LOGIN_PASSWORD: 'web.login_password',
  EMAIL_SUB: 'web.email_sub',
  PAY_SUCCESS: 'web.pay_success',
  VERIFY_EMAIL: 'web.verify_email',
  VERIFY_PHONE: 'web.verify_phone',
  // ADDR_ADD: 'web.addr_add',
  ADDR_EDIT: 'web.addr_edit',
  SMS_SUB: 'web.sms_sub',
  COMM_PREF: 'web.comm_pref',
  ONLINE_MEASUREMENT: 'web.online_measurement',
  QUICK_LOGIN: 'web.quick_login',
  CHECKOUT_SUBMIT: 'web.checkout_submit',
  GUEST_CHECKOUT_LOGIN: 'web.guest_checkout_login',
  GUEST_CHECKOUT_SUBMIT: 'web.guest_checkout_submit',
  GUEST_CHECKOUT_PHONE: 'web.guest_checkout_phone',
  TERMS_UNSUBSCRIBE: 'web.terms_unsubscribe',
} as const;
// 自定义尺寸
export const CUSTOM_VALUE = 'custom';
// 给白色的筛选添加边框
export const COLOR_WHITE = 'White';

// 这些页面代表是否会把Emarsys的弹窗组件放到代码中，目前看着没啥用，我把弹窗都放开了。
export const CHECK_EMARSYS_PAGE_LIST = [
  '/',
  '/goods-list',
  '/search-result',
  '/goods-detail',
  '/cart',
  '/paymentSuccess',
  '/account/my-account',
];

export const DIRECTLY_ADD_TO_CART_PARAMS = {
  // 详情页直接加入购物车数据
  od_sph: '',
  os_sph: '',
  od_cyl: '',
  os_cyl: '',
  od_add: '',
  os_add: '',
  od_axis: '',
  os_axis: '',
  pd: '',
  pd_r: '',
  pd_l: '',
  od_pv: '',
  os_pv: '',
  od_bd: '',
  os_bd: '',
  od_pv_r: '',
  os_pv_r: '',
  od_bd_r: '',
  os_bd_r: '',
  prescription_type: '',
  lens_id: 0,
  coating_id: 0,
};

export const NAV_TYPE = {
  WEB_FOOTER: 2,
  WAP_FOOTER: 5,
  WEB_HEADER: 10,
  WAP_HEADER: 9,
};

export const SHOW_APP_DOWNLOAD_BANNER_PAGE_LIST = {
  WEB: [],
  WAP: ['/'],
};

// 当切换到这些页面的时候，导航栏需要隐藏
export const HIDE_HEADER_PAGE_LIST = {
  WEB: ['/lens-process', '/frame-process', '/payment', '/paymentNew'],
  WAP: ['/lens-process', '/frame-process', '/payment', '/paymentNew', '/cart', '/activity-page'],
};

// 当切换到这些页面的时候，底部需要隐藏
export const HIDE_FOOTER_PAGE_LIST = {
  WEB: [
    '/lens-process',
    '/frame-process',
    '/cart',
    '/payment',
    '/paymentNew',
    '/account/my-orders',
    '/sms-subscribe',
    '/sms-preferences-update',
    '/subscribe-success',
  ],
  WAP: [
    '/lens-process',
    '/frame-process',
    '/cart',
    '/payment',
    '/paymentNew',
    '/price-difference',
    '/price-difference-payment-successful',
    '/price-difference-payment-failed',
    '/account/my-orders',
    '/account/transaction-detail',
    '/account/zeelool-rewards',
    '/account/account-settings',
    '/account/account-security',
    '/our-story-zeelool',
    '/account/tickets-history',
    '/account/zing',
    '/account/my-wishlist',
    '/coupons',
    '/account/my-coupons',
    '/account/refer-a-friend',
    '/account/my-prescriptions',
    '/account/my-prescriptions/add-prescription',
    '/account/my-address-book',
    '/account/my-reviews',
    '/account/my-reviews/write-review',
    '/account/points-mall-detail',
    '/account/points-mall',
    '/account/recently-viewed',
    '/account/questionnaires-list',
    '/account/communication-preferences',
    '/account/my-card',
    '/account/my-wallet',
    '/activity-page',
    '/delete-account',
    '/diva-eyeglasses',
    '/advance-search',
    '/sms-subscribe',
    '/sms-preferences-update',
    '/subscribe-success',
  ],
};

// 当切换到这些页面的时候，底部需要展示订阅框
export const SHOW_FOOTER_SUBSCRIBE_PAGE_LIST = {
  WEB: [
    '/',
    '/about-zeelool',
    '/return-refund',
    '/shipping-tracking',
    '/packaging',
    '/write-for-us',
  ],
  WAP: ['/', '/about-zeelool', '/return-refund', '/shipping-tracking', '/packaging'],
};

// 当切换到这些页面的时候，导航栏需要开启暗黑模式
export const HEADER_DARK_MODE_PAGE_LIST = ['/blue-light-blocking-glasses'];

export const HIDE_DT_BANNER_PAGE_LIST = ['/blue-light-blocking-glasses', '/delete-account'];

export const UNPAID_ICON_SHOW_PAGE_LIST = [
  '/',
  '/cart',
  '/goods-list',
  '/goods-detail',
  '/account/my-account',
  '/search-result',
  '/track-order',
  '/account/my-wishlist',
  '/account/recently-viewed',
];

export const COUPON_ICON_SHOW_PAGE_LIST = [
  '/cart',
  '/',
  '/goods-list',
  '/goods-detail',
  '/campaigns',
  '/campaigns/sunglasses-sale',
  '/campaigns/zeelool-x-ulike',
  '/campaigns/french-summer-edit-glasses',
];

export const CUSTOMER_SERVICE_ICON_HIDDEN_PAGE_LIST = [
  '/payment',
  '/anniversary-page',
  '/anniversary-helper',
  '/account/questionnaire-content',
  '/lens-process',
  '/frame-process',
];

export const SCROLL_TO_TOP_ICON_HIDDEN_PAGE_LIST = ['/payment', '/lens-process', '/frame-process'];

/** 这些页面不展示整个右侧悬浮区（优惠券/客服/未支付/回到顶部） */
export const HIDE_RIGHT_BOTTOM_FLOATING_PAGE_LIST = [
  '/sms-subscribe',
  '/sms-preferences-update',
  '/subscribe-success',
];

/** 这些页面不展示全局弹窗（领券/问卷/赠品/营销等） */
export const HIDE_GLOBAL_DIALOG_PAGE_LIST = [
  '/sms-subscribe',
  '/sms-preferences-update',
  '/subscribe-success',
];

export const APP_DOWNLOAD_GUIDE_ICON_SHOW_PAGE_LIST = [
  '/',
  '/goods-list',
  '/campaigns',
  '/campaigns/sunglasses-sale',
  '/campaigns/zeelool-x-ulike',
  '/campaigns/french-summer-edit-glasses',
];

export const NO_DATA = '-';

export const ZL_PAY_FLAG = 'zl-payFlag';
export const ZL_TOKEN = 'zl-token';
export const ZL_USERINFO = 'zl-userinfo';
export const ZL_OLDLEVEL = 'zl-oldlevel';
export const MOBILE_SCREEN_WIDTH = 680;

/**
 * @description: 首页预览路径常量
 * 路径为 "zeelool" 的MD5小写32位字符串
 */
export const HOME_PREVIEW_PATH = '/df4fd1133774db90d2761ac59975ecaf';
export const STYLE_HUB_PREVIEW_PATH = '/776d767a2d6dfef576e7f9b344a58731';

// 1 商品分组，2平台sku，3 系统页面，4 指定链接，5弹框,7关闭弹窗,8人群推荐分组
export const ZEELOOL_JUMP_TYPE = {
  PRODUCT_GROUP: 1,
  SKU: 2,
  SYSTEM_PAGE: 3,
  LINK: 4,
  POPUP: 5,
  CLOSE_POPUP: 7,
  CROWD_RECOMMEND: 8,
};

/**
 * @description: 处方名输入校验规则
 * 1、允许输入符号（中文字符、汉字除外）；新输入通过 PRESCRIPTION_NAME_FORMAT_INPUT 过滤空格，不允许键入空格
 * 2、取消原有输入符号的提示
 * 3. 需要支持特殊字符 à â ç é è ê ë î ï ô œ ù û ü ÿ À Â
 * 4、校验正则允许含空格（与输入过滤分离），用于兼容历史数据中已带空格的处方名
 * 与 app 端保持一致，使用范围，配镜流程中添加处方、个人中心添加处方
 * https://devops.aliyun.com/projex/project/ce85697916dd382a20b8106373/req/3ed03e4603ae96f019bf8b8f42
 */
export const PRESCRIPTION_NAME_PATTERN = /^[^\u4E00-\u9FA5]{1,20}$/;
export const PRESCRIPTION_NAME_FORMAT_INPUT = (value: string) =>
  value.replace(/[\u4E00-\u9FA5\s]/g, '');

// 切换页面的时候，不需要滚动到顶部的页面列表，这些页面需要记住滚动位置
export const NO_SCROLL_TO_TOP_PAGE_LIST = ['/', '/goods-list', '/goods-detail'];

export const LANG_ALTERNATE = [
  {
    href: 'https://www.zeelool.com/',
    hreflang: 'en-US',
  },
  {
    href: 'https://de.zeelool.com/',
    hreflang: 'de',
  },
  {
    href: 'https://fr.zeelool.com/',
    hreflang: 'fr',
  },
  {
    href: 'https://ca.zeelool.com/',
    hreflang: 'en-CA',
  },
  {
    href: 'https://uk.zeelool.com/',
    hreflang: 'en-GB',
  },
  {
    href: 'https://www.zeelool.com/',
    hreflang: 'en',
  },
  {
    href: 'https://www.zeelool.com/',
    hreflang: 'x-default',
  },
];
export const SIGNATURE_API_LIST = [
  '/api/auth/login',
  '/api/auth/register',
  '/api/auth/fast_register',
];

/**
 * @deprecated Use `@/utils/env/helper` instead.
 */
export { IS_DE, IS_FR, IS_UK, IS_US, IS_CA, IS_DE_FR } from './env/helper';
// 非处方类型
export const NON_PRESCRIPTION_TYPES = [
  EPrescriptionType.NON_PRESCRIPTION,
  EPrescriptionType.FRAME_ONLY,
  EPrescriptionType.SUNGLASSES_NON_PRESCRIPTION,
];
